import focusWithin from '@plugins/focus-within';

export default () => {

  if ($('.site-header').length) {
    const $sideNav = $('.js-side-nav'),
          $sideNavTrigger = $('.js-side-nav-trigger'),
          $sideNavClose = $('.js-side-nav-close'),
          $search = $('.site-header-search-container'),
          $searchTrigger = $('.js-search-open'),
          $searchClose = $('.js-site-header-search-close');

    // Toggle class on nav items on focus/blur of descendants
    focusWithin('.site-header-item', '-dropdown-open');
    focusWithin('.site-header-utility-nav-item', '-dropdown-open');

    // toggle display of main and utility nav dropdowns on focus and blur
    const $navItems = $('.site-header-item', '.site-header-utility-nav-item');
    $navItems.each((index, navItem) => {
      $(navItem)
        .on('focus', ':focusable', (e) => {
          $navItems.removeClass('-dropdown-open');
          $(e.delegateTarget).addClass('-dropdown-open');
        })
        .on('blur', ':focusable', (e) => {
          $(e.relatedTarget).parents(navItem).siblings().removeClass('-dropdown-open');
        })
      ;
    });

    // toggle display of dropdown on dropdown hover
    $('.site-header-nav a[data-children="true"], .site-header-nav ul ul').on('mouseenter mouseleave', (e) => {
      const $navItem = $(e.currentTarget).parent();
      e.type === 'mouseenter' ? $navItem.addClass('-dropdown-open') : $navItem.removeClass('-dropdown-open');
    });

    $sideNavTrigger.on('click', (e) => {
      e.preventDefault();

      $sideNav.attr('data-menu', 'open');
      $sideNav.attr('aria-hidden', 'false');
    });

    $sideNavClose.on('click', () => {
      $sideNav.attr('data-menu', 'closed');
      $sideNav.attr('aria-hidden', 'true');
    });

    $searchTrigger.on('click', (e) => {
      e.preventDefault();

      $search.attr('data-menu', 'open');
      $search.attr('aria-hidden', 'false');

    });

    $searchClose.on('click', () => {
      $search.attr('data-menu', 'closed');
      $search.attr('aria-hidden', 'true');

    });
  }
};
